export const NAMESPACE = 'KanBo/userRoles/'
export const SET = NAMESPACE + 'SET'
export const ADD = NAMESPACE + 'ADD'
export const REMOVE = NAMESPACE + 'REMOVE'

const initialState = {}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SET:
      return {
        ...state,
        [action.payload.userId]: action.payload.roles
      }
    case ADD:
      return {
        ...state,
        [action.payload.userId]: [
          ...(state[action.payload.userId] || []),
          action.payload.role
        ]
      }
    case REMOVE:
      return {
        ...state,
        [action.payload.userId]:
          state[action.payload.userId]
            ? state[action.payload.userId].filter(role => role !== action.payload.role)
            : []
      }
    default: return state
  }
}

export function set ({ userId, roles }) {
  return {
    type: SET,
    payload: {
      userId,
      roles,
    }
  }
}

export function add ({ userId, role }) {
  return {
    type: ADD,
    payload: {
      userId,
      role,
    }
  }
}

export function remove ({ userId, role }) {
  return {
    type: REMOVE,
    payload: {
      userId,
      role,
    }
  }
}
